// extracted by mini-css-extract-plugin
export default {"msg_container_msg":"Message_msg_container_msg__GUP36","msg_container_icon":"Message_msg_container_icon__drfCT"};